import Select, { ListOption } from "@/Atoms/Select/Select";
import InputError from "@/Components/InputError";
import Choice from "@/Molecules/Choice/Choice";

export type PaperSelectProps = {
  value?: string[] // papers
  type?: 'paper' | 'online_only' // online_only or paper
}

export default (
  {
    value,
    type,
    papers,
    errors,
    required,
    onChange,

  }: PaperSelectProps & {
    papers: [{ label: string, value: string }]
    errors?: any
    required: boolean
    onChange: (state: PaperSelectProps) => void
  }
) => {
  
  return <Choice
    title={'In welke krant(en) is/wordt de advertentie geplaatst?'}
    value={type}
    error={errors?.paper_type}
    required={required}
    onChange={type => onChange({
      type: type
    })}
    firstElementClassname={'w-3/5'}
    choices={{
      paper: () => {
        return <div data-testid={'in-papers'}>
          In de volgende krant(en):<br />
          <Select
            isClearable
            isMulti
            dataTestid={'papers'}
            options={papers}
            value={papers.filter(paper => value?.includes(paper.value))}
            onChange={(papers: ListOption[] | any) => onChange({
              value: papers.map((paper: ListOption) => paper.value),
              type: 'paper',
            })}
            noOptionsMessage={() => 'Geen zoekresultaten'}
          />
          <InputError message={errors?.papers} className="mb-2" />
        </div>
      },
      online_only: () => {
        return <div data-testid={'not-in-papers'}>Niet geplaatst in een krant</div>
      },
    }}
  />
}